import { Badge } from './badge';
import { CheckCircle, XCircle, AlertCircle } from 'lucide-react';

// Helper function to format status badges
export const formatStatusBadge = (status: string) => {
  switch (status.toLowerCase()) {
    case 'accepted':
      return (
        <Badge className="bg-green-100 text-green-800">
          <CheckCircle className="h-3 w-3 mr-1" />
          Accepted
        </Badge>
      );
    case 'cancelled':
      return (
        <Badge className="bg-red-100 text-red-800">
          <XCircle className="h-3 w-3 mr-1" />
          Cancelled
        </Badge>
      );
    case 'rejected':
      return (
        <Badge className="bg-red-100 text-red-900">
          <XCircle className="h-3 w-3 mr-1" />
          Rejected
        </Badge>
      );
    case 'completed':
      return (
        <Badge className="bg-blue-100 text-blue-800">
          <CheckCircle className="h-3 w-3 mr-1" />
            Completed
        </Badge>
      );
    case 'pending':
      return (
        <Badge className="bg-yellow-100 text-yellow-800 border-yellow-300">
          <AlertCircle className="h-3 w-3 mr-1" />
          Pending
        </Badge>
      );
    case 'incompleted':
      return (
        <Badge className="bg-orange-100 text-orange-800 border-orange-300">
          <AlertCircle className="h-3 w-3 mr-1" />
          Incompleted
        </Badge>
      );
    default:
      return <Badge variant="outline">{status}</Badge>;
  }
};

// Helper function to format date
export const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};